import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Cookies from 'js-cookie';
var userAgent = window.navigator.userAgent;

var DeviceBaseInfo = function DeviceBaseInfo() {
  _classCallCheck(this, DeviceBaseInfo);

  _defineProperty(this, "isNotRn", true);

  _defineProperty(this, "isWeb", true);

  _defineProperty(this, "isMini", false);

  _defineProperty(this, "isIOS", !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/));

  _defineProperty(this, "isAndroid", userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1);

  _defineProperty(this, "vid", '');

  _defineProperty(this, "pid", '');

  _defineProperty(this, "cid", Cookies.get('QN66') || '');

  _defineProperty(this, "uid", Cookies.get('QN48') || '');

  _defineProperty(this, "sid", '');

  _defineProperty(this, "gid", '');

  _defineProperty(this, "mac", '02:00:00:00:00:00');

  _defineProperty(this, "model", '');

  _defineProperty(this, "manufacturer", '');

  _defineProperty(this, "platform", 'web');

  _defineProperty(this, "osVersion", '');

  _defineProperty(this, "scheme", '');

  _defineProperty(this, "qrn_version", '');

  _defineProperty(this, "releaseType", '');

  _defineProperty(this, "isIphoneX", false);

  _defineProperty(this, "uuid", Cookies.get('_s') || '');

  _defineProperty(this, "userId", '');

  _defineProperty(this, "idfa", '');

  _defineProperty(this, "notchInfo", {});

  _defineProperty(this, "immersiveInfo", {});
};

export { DeviceBaseInfo as default };